import { useNavigate } from "react-router-dom";
import { generateFirstLetterBox } from "../../utils/generateFirstLetterBox";
import { paths } from "../../routes/paths";
import styles from "../../styles/_containers/_employees/items.module.scss";

const Items = ({
  data,
  hasSearch,
  setIsOpen,
  setSelectedEmployee,
  setIsConfirmModalOpen,
}) => {
  return (
    <section className={styles.container} aria-label="רשימת עובדים">
      <div className={styles.listHeader}>
        <div>
          <h2>אנשי הצוות</h2>
          <p>{data.length} {data.length === 1 ? "עובד" : "עובדים"} ברשימה</p>
        </div>
      </div>

      <div className={styles.tableHeader} aria-hidden="true">
        <span>עובד</span>
        <span>פרטי קשר</span>
        <span>תיאור ותפקיד</span>
        <span>פעולות</span>
      </div>

      {data.length === 0 ? (
        <div className={styles.emptyState}>
          <span aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="1.8" /><path d="M2.5 20v-1a6.5 6.5 0 0 1 13 0v1M17 10v6M14 13h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg></span>
          <strong>{hasSearch ? "לא נמצאו עובדים מתאימים" : "עדיין אין אנשי צוות"}</strong>
          <p>{hasSearch ? "אפשר לנסות שם או מספר טלפון אחר" : "הוספת עובד חדש תציג אותו כאן"}</p>
        </div>
      ) : (
        <div className={styles.rows}>
          {data.map((employee) => (
            <EmployeeRow
              key={employee.id}
              employee={employee}
              setSelectedEmployee={setSelectedEmployee}
              setIsOpen={setIsOpen}
              setIsConfirmModalOpen={setIsConfirmModalOpen}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default Items;

const EmployeeRow = ({ employee, setSelectedEmployee, setIsOpen, setIsConfirmModalOpen }) => {
  const navigate = useNavigate();
  const phone = employee.business_phone || employee.phone || "";
  const description = employee.description || "לא נוסף תיאור לעובד";

  const openEditor = () => {
    setSelectedEmployee(employee);
    setIsOpen("edit");
  };

  return (
    <article className={styles.item}>
      <div className={styles.identity}>
        <div className={styles.avatar}>
          {generateFirstLetterBox(employee.name)}
          {employee.profile && (
            <img
              src={employee.profile}
              alt=""
              onError={(event) => { event.currentTarget.style.display = "none"; }}
            />
          )}
        </div>
        <div className={styles.name}>
          <h3>{employee.name || "עובד ללא שם"}</h3>
          <span className={styles.activeBadge}><i /> פעיל</span>
        </div>
      </div>

      <div className={styles.contact}>
        {phone ? (
          <a href={`tel:${phone}`} onClick={(event) => event.stopPropagation()}>
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7.2 3.5 9.5 8l-2 2a16 16 0 0 0 6.5 6.5l2-2 4.5 2.3v2.4a2 2 0 0 1-2.2 2A17.6 17.6 0 0 1 2.8 5.7a2 2 0 0 1 2-2.2h2.4Z" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /></svg>
            <span>{phone}</span>
          </a>
        ) : <span className={styles.noPhone}>לא הוזן טלפון</span>}
      </div>

      <p className={styles.description} title={description}>{description}</p>

      <div className={styles.actions}>
        <button type="button" onClick={openEditor} aria-label={`עריכת ${employee.name}`} title="עריכת עובד">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m4 16.5-.8 4.3 4.3-.8L18.8 8.7a2.1 2.1 0 0 0-3-3L4 16.5Z" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /><path d="m14.5 7 2.5 2.5" stroke="currentColor" strokeWidth="1.7" /></svg>
          <span>עריכה</span>
        </button>
        <button type="button" onClick={() => navigate(paths.workingHours(employee.id))} aria-label={`שעות ושירותים של ${employee.name}`} title="שעות ושירותים">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.7" /><path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /></svg>
          <span>שעות</span>
        </button>
        <button type="button" className={styles.deleteBtn} onClick={() => setIsConfirmModalOpen(employee.id)} aria-label={`מחיקת ${employee.name}`} title="מחיקת עובד">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /></svg>
          <span>מחיקה</span>
        </button>
      </div>
    </article>
  );
};
